import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetMapActivityDetails } from 'domain/usecases/dashboard';

export class RemoteGetMapActivityDetails implements GetMapActivityDetails {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetMapActivityDetails.Result>,
  ) {}

  async execute(
    params: GetMapActivityDetails.Params,
  ): Promise<GetMapActivityDetails.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${this.url}/${params.activityhashid}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
